import React, { useEffect, useState } from "react";
import "./Stake.css";
import Navbar from "../components/Navbar/Navbar";
import fetchData from "../js/fetchData";
import { fetchUserData, fetchAccounts } from "../js/fetchUserData";
import Modal from "../components/Modal/Modal";
import Popup from "../components/Popup/Popup";
import { writeContract } from "../js/writeContract";
import { approveBearContract, approveLpContract } from "../js/approveContracts";
import TxStatus from "../components/TxStatus/TxStatus";
import Loader from "../components/Loader/Loader";
import Footer from "../components/Footer/Footer";

function Stake() {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "How many?",
    content: "",
  });
  const [wallet, setWallet] = useState(null);
  const [totalStaked, setTotalStaked] = useState({ bears: 0, lp: 0 });
  const [userData, setUserData] = useState({
    dataNew: [],
    stakesOld: [],
    bearsOwned: null,
    totalStaked: 0,
    honey: 0,
    lpData: { balance: 0, earned: 0, staked: 0 },
    unclaimedHoney: 0,
    approved: { bears: false, lp: false },
  });
  const [popupData, setPopupData] = useState({
    show: false,
    color: "",
    message: "",
  });
  const [txStatus, setTxStatus] = useState("none");

  useEffect(() => {
    updateUserData();
  }, []);

  async function updateUserData() {
    const bears = await fetchData("/api/staking/bears/total");
    const lp = await fetchData("/api/staking/lp/total");
    setTotalStaked({ bears: bears, lp: lp });

    setWallet(await fetchAccounts());

    const data = await fetchUserData("/api/staking/bears/user");
    setUserData(data);
  }

  useEffect(() => {
    console.log(userData);
  }, [userData]);

  window.ethereum?.on("accountsChanged", (accounts) => {
    window.location.reload();
  });

  function has(e1, e2) {
    if (!e2) return userData[e1] && userData[e1] > 0 ? true : false;
    else return userData[e1][e2] && userData[e1][e2] > 0 ? true : false;
  }

  function handleContract(type, id) {
    console.log(type, id);
    if (type === "unstake") {
      if (userData.stakesOld.length > 0 && userData.dataNew.length < 1)
        if (id)
          writeContract(
            setTxStatus,
            setPopupData,
            userData,
            "unstakeNFT",
            "oldContract",
            id
          );
        else
          writeContract(
            setTxStatus,
            userData,
            "batchUnstakeNFT",
            "oldContract",
            id
          );
      else if (userData.stakesOld.length < 1 && userData.dataNew.length > 0)
        writeContract(
          setTxStatus,
          setPopupData,
          userData,
          "unstake",
          "newContract",
          id
        );
    } else if (type === "claim") {
      if (userData.stakesOld.length > 0 && userData.dataNew.length < 1)
        writeContract(
          setTxStatus,
          setPopupData,
          userData,
          "claimBatchReward",
          "oldContract",
          id
        );
      else if (userData.stakesOld.length < 1 && userData.dataNew.length > 0)
        writeContract(
          setTxStatus,
          setPopupData,
          userData,
          "claimRewards",
          "newContract",
          id
        );
    }
  }

  function submitUnstake(e, func, contractName, value) {
    e.preventDefault();
    setShowModal(false);
    writeContract(
      setTxStatus,
      setPopupData,
      userData,
      func,
      contractName,
      value
    );
  }

  function inputForm(title, available, func, contractName, placeholder) {
    return {
      title: title,
      available: <p>Available: {available}</p>,
      content: (
        <form
          id="amount-form"
          onSubmit={(e) => {
            submitUnstake(
              e,
              func,
              contractName,
              document.getElementById("amount-input").value
            );
            e.target.reset();
          }}
        >
          <input id="amount-input" type="text" placeholder={placeholder} />
          <button type="submit" form="amount-form">
            Submit
          </button>
        </form>
      ),
    };
  }

  function renderBearsStaked() {
    if (userData.dataNew?.length === 0) return;

    return userData.dataNew?.map((bear, index) => (
      <article className="staked-bear" key={index}>
        <div>
          <img
            src={`https://ipfs.io/ipfs/QmPeqgGzk4Pn4qTe2UNsajrUemuCpxYGK67SU6hXcPYE6Z/${parseInt(
              bear.id
            )}.png`}
            alt="Baller Bear"
          />
          <div>
            <p>Baller Bear #{bear.id}</p>
            <p>Honey gathered: {Number(bear.honey).toFixed(0)}</p>
          </div>
        </div>
        <div className="staked-bear-buttons">
          <button onClick={() => handleContract("unstake", bear.id)}>
            Unstake
          </button>
          <button
            onClick={() => handleContract("claim", bear.id)}
            disabled={!Number(bear.honey).toFixed(0) >= 1}
          >
            Claim
          </button>
        </div>
      </article>
    ));
  }

  function formatAddress(address) {
    var formatted = null;
    if (address !== null)
      formatted = address.substring(0, 5) + "..." + address.substring(38, 42);
    return formatted;
  }

  return (
    <div className="stake">
      {window.ethereum ? (
        <div
          className="loading-overlay"
          style={{ display: userData.bearsOwned !== null ? "none" : "flex" }}
        >
          <Loader size="3rem" />
        </div>
      ) : (
        <div className="loading-overlay">
          <h1>MetaMask not detected</h1>
        </div>
      )}

      <Modal show={showModal} setShow={setShowModal} content={modalContent} />
      <Navbar />
      <Popup data={popupData} setData={setPopupData} />

      <section className="container">
        <div className="dashboard-header mb0">
          <h1>Dashboard</h1>
          {txStatus === "none" ? (
            <button
              className={
                wallet
                  ? "connect-button mid-button"
                  : "connect-button reverse-button"
              }
              onClick={async (e) => {
                setWallet(await fetchAccounts());
              }}
            >
              {wallet ? formatAddress(wallet.accounts[0]) : "Connect"}
            </button>
          ) : (
            <TxStatus _status={txStatus} />
          )}
        </div>

        <div className="wrapper mb1">
          <section className="dash dash-container">
            <h2>Honey</h2>
            <p className="gray">Balance</p>
            <p>{userData.honey}</p>
            <p className="gray">Unclaimed</p>
            <p>{userData.unclaimedHoney}</p>
          </section>

          <section className="dash dash-container">
            <h2>Bears</h2>
            <p className="gray">Owned</p>
            <p>{userData.bearsOwned}</p>
            <p className="gray">Staked</p>
            <p>{userData.totalStaked}</p>
          </section>

          <section className="dash dash-container">
            <h2>LP</h2>
            <p className="gray">Owned</p>
            <p>{userData.lpData?.balance}</p>
            <p className="gray">Staked</p>
            <p>{userData.lpData?.staked}</p>
          </section>
        </div>

        <section className="staking-wrapper dash dash-container mb1">
          <div
            className="approve-overlay"
            style={{ display: userData.approved?.bears ? "none" : "flex" }}
          >
            <h2>Bear Staking</h2>
            <button
              onClick={() => {
                approveBearContract();
              }}
            >
              Start Staking
            </button>
          </div>

          <div className="header mb1">
            <h2>Bears Staked</h2>
            <p className="gray">Total staked: {totalStaked.bears}</p>
          </div>

          <div className="stake-buttons mb1">
            <button
              onClick={() => {
                setModalContent(
                  inputForm(
                    "Stake Bears",
                    userData.bearsOwned,
                    "stake",
                    "newContract",
                    "Bear IDs - Ex: 2568, 250, 3512"
                  )
                );
                setShowModal(true);
              }}
              disabled={!has("bearsOwned")}
            >
              Stake
            </button>
            <button
              onClick={() => handleContract("unstake", null)}
              disabled={!has("totalStaked")}
            >
              Unstake All
            </button>
            <button
              onClick={() => handleContract("claim", null)}
              disabled={!has("totalStaked")}
            >
              Claim All
            </button>
          </div>

          <div className="bears-staked-container">{renderBearsStaked()}</div>
        </section>

        <section className="staking-wrapper dash dash-container mb1">
          <div
            className="approve-overlay"
            style={{ display: userData.approved?.lp > 1 ? "none" : "flex" }}
          >
            <h2>LP Staking</h2>
            <button
              onClick={() => {
                approveLpContract();
              }}
            >
              Start Staking
            </button>
          </div>

          <div className="header mb1">
            <h2>LP Tokens Staked</h2>
            <p className="gray">Total staked: {totalStaked.lp}</p>
          </div>

          <div className="stake-buttons mb1">
            <button
              onClick={() => {
                setModalContent(
                  inputForm(
                    "Stake LP",
                    userData.lpData.balance,
                    "stake",
                    "lpContract",
                    "Amount"
                  )
                );
                setShowModal(true);
              }}
              disabled={!has("lpData", "balance")}
            >
              Stake
            </button>
            <button
              onClick={() => {
                setModalContent(
                  inputForm(
                    "Unstake LP",
                    userData.lpData.staked,
                    "withdraw",
                    "lpContract",
                    "Amount"
                  )
                );
                setShowModal(true);
              }}
              disabled={!has("lpData", "staked")}
            >
              Unstake
            </button>
            <button
              onClick={() =>
                writeContract(
                  setTxStatus,
                  setPopupData,
                  userData,
                  "claimHoney",
                  "lpContract",
                  null
                )
              }
              disabled={!has("lpData", "earned")}
            >
              Claim
            </button>
          </div>

          <div className="lp-info">
            <div className="lp-dash">
              <h3>{userData.lpData?.staked}</h3>
              <p>Staked</p>
            </div>
            <div className="lp-dash">
              <h3>{userData.lpData?.earned}</h3>
              <p>Honey earned</p>
            </div>
          </div>
        </section>
      </section>
      <Footer />
    </div>
  );
}

export default Stake;
